import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const entityAccessReceivedInvitationsSelector = (state: AppState) => state.frontendState.entityAccessInvitations.receivedInvitations;
export const useEntityAccessReceivedInvitationsSelector = () => useSelector(entityAccessReceivedInvitationsSelector);
